import React, {useEffect} from "react";
import {Col, Row} from "antd";
import {ExpandableStyledTable} from "../../../../../_defaultComponents/ExpandableStyledTable/ExpandableStyledTable.styles";
import {formatMoney} from "../../../../../../utils/moneyHelper";
import {useCourierWalletSubTab} from "./useCourierWalletSubTab";
import {WalletTransactions} from "./walletTransactions/WalletTransactions";
import moment from "moment";

export const CourierWalletSubTab = ({
    courier,
    canRender = false,
    walletData,
    walletStartDateRecall,
    selectedDateRange,
    onDateRangeChange
}) => {
    const {wallet, walletLoading, pagination, setPagination} = useCourierWalletSubTab({
        courier,
        canRender,
        walletData,
        selectedDateRange,
        onDateRangeChange
    });

    const handleTableChange = (newPagination) => {
        setPagination({
            skip: (newPagination.current - 1) * newPagination.pageSize,
            limit: newPagination.pageSize
        });
    };

    useEffect(() => {
        if (canRender && wallet && onDateRangeChange) {
            onDateRangeChange([moment(wallet?.createdAt), selectedDateRange?.[1]]);
        }
    }, [walletStartDateRecall]);

    const renderTransactionTable = (dailyTransaction, aa, bb) => {
        const {_id: dailyTransactionId} = dailyTransaction;
        return (
            <>
                <WalletTransactions
                    externalId={courier?._id}
                    dailyTransactionId={dailyTransactionId}
                />
            </>
        );
    };

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}></Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{textAlign: "right"}}>
                {/* Para çekme bloklama butonları üst kısımda BlockWithdrawButton bileşeninde gösteriliyor */}
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <ExpandableStyledTable
                    loading={walletLoading}
                    rowKey="_id"
                    expandable={{
                        expandedRowRender: renderTransactionTable,
                        defaultExpandedRowKeys: ["0"]
                    }}
                    onChange={handleTableChange}
                    pagination={{
                        current: Math.floor(pagination.skip / pagination.limit) + 1,
                        pageSize: pagination.limit,
                        total: wallet?.totalDailyTransactions || 0,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kayıt`,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        size: 'small'
                    }}
                    scroll={{x: 902}}
                    columns={[
                        {
                            title: "Gün",
                            dataIndex: "date",
                            key: "date",
                            width: 100,
                            render: date => (date ? moment(date).format("DD.MM.YYYY") : "-"),
                            onCell: () => ({ "data-label": "Gün" })
                        },
                        {
                            title: "Başlangıç Bakiyesi",
                            dataIndex: ["metaData", "startBalanceOfDay"],
                            key: "startBalanceOfDay",
                            width: 150,
                            render: startBalanceOfDay => formatMoney({amount: startBalanceOfDay}),
                            onCell: () => ({ "data-label": "Başlangıç Bakiyesi" })
                        },
                        {
                            title: "Bitiş Bakiyesi",
                            dataIndex: ["endBalanceOfDay"],
                            key: "endBalanceOfDay",
                            width: 150,
                            render: endBalanceOfDay => formatMoney({amount: endBalanceOfDay}),
                            onCell: () => ({ "data-label": "Bitiş Bakiyesi" })
                        },
                        {
                            title: "Para Çekme",
                            dataIndex: "totalWithdrawAmount",
                            key: "totalWithdrawAmount",
                            width: 150,
                            render: totalWithdrawAmount =>
                                formatMoney({amount: totalWithdrawAmount}),
                            onCell: () => ({ "data-label": "Para Çekme" })
                        },
                        {
                            title: "Nakit Tahsilat",
                            dataIndex: "totalCashOrderAmount",
                            key: "totalCashOrderAmount",
                            width: 150,
                            render: totalCashOrderAmount =>
                                formatMoney({amount: totalCashOrderAmount}),
                            onCell: () => ({ "data-label": "Nakit Tahsilat" })
                        },
                        {
                            title: "Faturalanmamış Nakit Kümülatif",
                            dataIndex: ["metaData", "cumulativeWithdrawCashAmount"],
                            key: "cumulativeWithdrawCashAmount",
                            width: 150,
                            render: cumulativeWithdrawCashAmount =>
                                formatMoney({amount: cumulativeWithdrawCashAmount}),
                            onCell: () => ({ "data-label": "Faturalanmamış Nakit Kümülatif" })
                        },
                        {
                            title: "Kazanç",
                            dataIndex: "totalDailyEarningAmount",
                            key: "totalDailyEarningAmount",
                            width: 150,
                            render: totalDailyEarningAmount =>
                                formatMoney({amount: totalDailyEarningAmount}),
                            onCell: () => ({ "data-label": "Kazanç" })
                        }
                        /* {
                            title: "Günlük İşlem Tutarı",
                            dataIndex: "balance",
                            key: "balance",
                            width: 150,
                            render: balance => formatMoney({amount: balance})
                        } */
                    ]}
                    dataSource={
                        wallet?.dailyTransactions?.sort((a, b) =>
                            moment(b.date).diff(moment(a.date))
                        ) || []
                    }
                />
                {courier?.isWalletActive === false && (
                    <div
                        style={{
                            textAlign: "center",
                            padding: "40px",
                            color: "rgba(0, 0, 0, 0.45)"
                        }}
                    >
                        <p>
                            Cüzdan kullanıma kapatılmış. Cüzdanı tekrar aktifleştirmek için
                            yukarıdaki "Cüzdanı Tekrar Aktive Et" butonunu kullanın.
                        </p>
                    </div>
                )}
            </Col>
        </Row>
    );
};
